import { Box, SxProps, Theme } from '@mui/material';
import { Children, ReactNode } from 'react';

interface Props {
  minWidthItem: number;
  sx?: SxProps<Theme>;
  children: ReactNode;
  gap?: number;
}

const MobileScrollableList = ({
  minWidthItem,
  sx,
  children,
  gap = 2,
}: Props) => {
  const items = Children.toArray(children);

  return (
    <Box
      sx={{
        display: { xs: 'flex', md: 'none !important' },
        mx: { xs: -2 },
        gap: gap,
        ...(Array.isArray(sx) ? sx : [sx]),
        overflowX: 'scroll',
        overflowY: 'hidden',
        scrollBehavior: 'smooth',

        //Added to remove scrollbar on FireFox
        scrollbarWidth: 'none',

        WebkitOverflowScrolling: 'touch',

        '::-webkit-scrollbar': {
          display: 'none',
        },

        scrollSnapType: 'x mandatory',

        // Manually add spacing to the first and last item matching the container spacing
        '& > :first-of-type': {
          ml: { xs: 2 },
        },

        '& > :last-of-type': {
          mr: { xs: 2 },
        },
      }}
    >
      {items.map((item, key) => (
        <Box
          key={key}
          sx={{
            display: 'flex',
            flex: '1 auto',
            minWidth: minWidthItem,
            maxWidth: minWidthItem,
            scrollMargin: '0 16px',
          }}
        >
          {item}
        </Box>
      ))}
    </Box>
  );
};

export default MobileScrollableList;
